import type { ObjectId } from '@freightview/object-id'

import type { vOutput } from '../validation/index.ts'
import {
  vBoolean,
  vNonEmptyString,
  vObject,
  vOptional,
} from '../validation/schema/core.ts'

export type AccountBranding = {
  _id: ObjectId
  name: string
  logoUri: string
  isDefault: boolean
  createdDate: Date
  removedDate?: Date
}

export const createBrandSchema = vObject({
  name: vNonEmptyString(),
  isDefault: vOptional(vBoolean()),
})

export type CreateBrandRequest = vOutput<typeof createBrandSchema>
